import React, { forwardRef } from "react"
import styled from "styled-components"
forwardRef
const FourSimpleViewSVG = forwardRef((props, ref) => {
  return (
    <SVGWrapper ref={ref} width={props.width || 200} color={props.color} version="1.2" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 400 225">
      <title>New Project</title>
      <path id="Layer 1" className="s0" d="m0 0h400v225h-400z"/>
      <g id="Folder 1">
        <path id="Layer 2" className="s1 stream-feed" d="m12 20c0-3.3 2.7-6 6-6h132.4c3.3 0 6 2.7 6 6v69.3c0 3.3-2.7 6-6 6h-132.4c-3.3 0-6-2.7-6-6z"/>
        <path id="Layer 2 copy" className="s1 stream-feed" d="m164.6 20c0-3.3 2.7-6 6-6h132.4c3.3 0 6 2.7 6 6v69.3c0 3.3-2.7 6-6 6h-132.4c-3.3 0-6-2.7-6-6z"/>
        <path id="Layer 2 copy 2" className="s1 stream-feed" d="m12 107.7c0-3.3 2.7-6 6-6h132.4c3.3 0 6 2.7 6 6v69.4c0 3.3-2.7 6-6 6h-132.4c-3.3 0-6-2.7-6-6z"/>
        <path id="Layer 2 copy 3" className="s1 stream-feed" d="m164.6 107.7c0-3.3 2.7-6 6-6h132.4c3.3 0 6 2.7 6 6v69.4c0 3.3-2.7 6-6 6h-132.4c-3.3 0-6-2.7-6-6z"/>
        <path id="Layer 3" className="s1 browser-source" d="m318 21c0-3.3 2.7-6 6-6h59c3.3 0 6 2.7 6 6v153c0 3.3-2.7 6-6 6h-59c-3.3 0-6-2.7-6-6z"/>
        <g id="Folder 2">
          <path id="Shape 2" className="s2" d="m326.3 30l-0.1-5h53.8v5z"/>
          <path id="Shape 2 copy" className="s2" d="m326.3 40l-0.1-5h53.8v5z"/>
          <path id="Shape 2 copy 2" className="s2" d="m326.3 50l-0.1-5h53.8v5z"/>
          <path id="Shape 2 copy 3" className="s2" d="m326.3 60l-0.1-5h53.8v5z"/>
          <path id="Shape 2 copy 4" className="s2" d="m326.3 70l-0.1-5h53.8v5z"/>
          <path id="Shape 2 copy 5" className="s2" d="m326.3 80l-0.1-5h53.8v5z"/>
          <path id="Shape 2 copy 6" className="s2" d="m326.3 90l-0.1-5h53.8v5z"/>
          <path id="Shape 2 copy 7" className="s2" d="m326.3 100l-0.1-5h53.8v5z"/>
          <path id="Shape 2 copy 8" className="s2" d="m326.3 110l-0.1-5h53.8v5z"/>
          <path id="Shape 2 copy 9" className="s2" d="m326.3 120l-0.1-5h53.8v5z"/>
          <path id="Shape 2 copy 10" className="s2" d="m326.3 130l-0.1-5h53.8v5z"/>
          <path id="Shape 2 copy 11" className="s2" d="m326.3 140l-0.1-5h53.8v5z"/>
          <path id="Shape 2 copy 12" className="s2" d="m326.3 150l-0.1-5h53.8v5z"/>
          <path id="Shape 2 copy 13" className="s2" d="m326.3 160l-0.1-5h53.8v5z"/>
          <path id="Shape 2 copy 14" className="s2" d="m326.3 170l-0.1-5h53.8v5z"/>
        </g>
      </g>
    </SVGWrapper>
  )
})

export default FourSimpleViewSVG

const SVGWrapper = styled.svg`
  --color: ${props => props.color || '#fff'};
  .s0 { fill: none; stroke: var(--color); stroke-width: 10 }
  .s1 { fill: none; stroke: var(--color); stroke-width: 5 }
  .s2 { fill: var(--color) }

  .browser-source {
    stroke: var(--green-text);
    fill: var(--green-selected);
  }

  .stream-feed {
    ${'' /* fill: ; */}
  }
`
